import React from "react";
import { useParams } from "react-router-dom";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";
import { i18n } from "../../translate/i18n";

const Chat = () => {
  const { ticketId } = useParams();

  return (
    <div className="h-full flex overflow-hidden bg-white dark:bg-dark-800">
      {/* Tickets List Panel */}
      <div
        className={`h-full flex flex-col w-full md:w-[380px] md:min-w-[380px] border-r border-dark-200 dark:border-dark-700 ${
          ticketId ? "hidden md:flex" : "flex"
        }`}
      >
        <TicketsManager />
      </div>

      {/* Chat/Message Panel */}
      <div className={`flex-1 h-full flex flex-col overflow-hidden ${!ticketId ? "hidden md:flex" : "flex"}`}>
        {ticketId ? (
          <Ticket />
        ) : (
          <div className="hidden md:flex flex-1 items-center justify-center bg-dark-50 dark:bg-dark-900">
            <div className="text-center">
              <svg
                className="w-24 h-24 mx-auto text-dark-300 dark:text-dark-600 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              <p className="text-dark-500 dark:text-dark-400 text-lg">
                {i18n.t("chat.noTicketMessage")}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
